import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import api from '../../../../services/API';
import { toast } from 'react-toastify';

export default function ModalLimiteResgate(props) {
  const [limiteResgate, setLimiteResgate] = useState('');
  const [salvando, setSalvando] = useState(false);
  const [removendo, setRemovendo] = useState(false);

  useEffect(() => {
    if (props.show && props.premio) {
      if (props.premio.hasLimiteResgate && props.premio.limiteResgate) {
        setLimiteResgate(String(props.premio.limiteResgate));
      } else {
        setLimiteResgate('');
      }
    }
  }, [props.show, props.premio]);

  const salvar = async (e) => {
    e.preventDefault();
    
    if (!limiteResgate || limiteResgate === '' || limiteResgate === '0' || parseInt(limiteResgate) < 1) {
      toast.error('Informe um limite válido (mínimo 1)', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
      });
      e.stopPropagation();
      return false;
    }

    setSalvando(true);
    try {
      const resultado = await api.put(`/api/premios/${props.premio.id}`, {
        hasLimiteResgate: true,
        limiteResgate: parseInt(limiteResgate),
      });

      if (resultado) {
        toast.success('Limite de resgate atualizado com sucesso', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 3000,
        });
        props.onHide();
        props.onSuccess({
          ...props.premio,
          hasLimiteResgate: true,
          limiteResgate: parseInt(limiteResgate),
        });
      }
    } catch (error) {
      toast.error('Erro ao atualizar limite de resgate', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
      });
    } finally {
      setSalvando(false);
    }
  };

  const removerLimite = async () => {
    setRemovendo(true);
    try {
      const resultado = await api.put(`/api/premios/${props.premio.id}`, {
        hasLimiteResgate: false,
        limiteResgate: null,
      });

      if (resultado) {
        toast.success('Limite de resgate removido com sucesso', {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 3000,
        });
        props.onHide();
        props.onSuccess({
          ...props.premio,
          hasLimiteResgate: false,
          limiteResgate: null,
        });
      }
    } catch (error) {
      toast.error('Erro ao remover limite de resgate', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 3000,
      });
    } finally {
      setRemovendo(false);
    }
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Limite de Resgate</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={(e) => { e.preventDefault(); }}>
          <div className="form-group">
            <label htmlFor="limiteResgate">Quantidade do Limite</label>
            <input
              id="limiteResgate"
              name="limiteResgate"
              type="text"
              placeholder="Ex: 100"
              value={limiteResgate}
              onChange={(e) => {
                const valor = e.target.value.replace(/[^0-9]/g, '');
                setLimiteResgate(valor);
              }}
              autoFocus
              className="form-control"
              style={{
                color: '#495057'
              }}
            />
            <style>
              {`
                #limiteResgate::placeholder {
                  color: #6c757d !important;
                }
              `}
            </style>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-center align-items-center w-100">
          {props.premio?.hasLimiteResgate && (
            <button
              type="button"
              className="btn btn-secondary m-1"
              onClick={removerLimite}
              disabled={salvando || removendo}
            >
              {removendo ? 'REMOVENDO...' : 'REMOVER LIMITE'}
            </button>
          )}
          {salvando ? (
            <button
              type="button"
              className="btn btn-success m-1"
              disabled
            >
              SALVANDO...
            </button>
          ) : (
            <button
              type="button"
              className="btn btn-success m-1"
              onClick={salvar}
              disabled={removendo || !limiteResgate || limiteResgate === '0' || parseInt(limiteResgate) < 1}
            >
              SALVAR
            </button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
}

